import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import localforage from 'localforage';
import logger from '@/configured/logger';
import mixins from '@/mixins';

Vue.use(Vuex);

let store;

console.info('mixins', mixins);

if (!mixins.all.supportedFeaturesOfflineMode) {
  store = new Vuex.Store({});
} else {
  localforage.config({});

  const savedModules = [
    'authentication',
    'favorites',
    'home',
    'i18n',
    'navigation',
    'offlineDownload',
    'offlineQueue',
    'outbox',
    'products',
    'singles',
    'training',
    'user',
  ];

  const ignoredKeys = {
    authentication: ['working', 'passwordResetId', 'passwordResetCode'],
    user: ['sessionTimeout'],
  };

  const vuexLocal = new VuexPersistence({
    key: 'vuex',
    strictMode: true,
    modules: savedModules,
    storage: localforage,
    saveState: (key, state, storage) => {
      try {
        let jsonStringified = JSON.stringify(state);
        logger.info('saving state');
        return localforage.setItem(key, jsonStringified);
      } catch (err) {
        logger.error('error saving state');
      }
    },
    restoreState: (key, storage) =>
      new Promise((resolve) => {
        logger.info(`Restoring state for ${key}`);
        return localforage.getItem(key).then((value) => {
          let uncompressedValue = value;

          try {
            let jsonParsed = JSON.parse(uncompressedValue);
            return resolve(jsonParsed);
          } catch (err) {}

          return resolve(uncompressedValue);
        });
      }),
    reducer: (state) => {
      const result = {};
      savedModules.forEach((name) => {
        const store = Object.assign({}, state[name]);
        const ignored = ignoredKeys[name] || [];
        ignored.forEach((key) => delete store[key]);
        result[name] = store;
      });
      return result;
    },
    filter: (mutation) =>
      savedModules.some((mod) => mutation.type.indexOf(mod) === 0),
    asyncStorage: true,
  });

  store = new Vuex.Store({
    mutations: {
      RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
    },
    strict: true,
    plugins: [vuexLocal.plugin],
  });
}

export default store;
